import Utils from './utils';

export default class Popup {

	constructor(node) {
		this.node = node;
		this.icon = node.querySelector('[data-popup-icon]');
		this.message = node.querySelector('[data-popup-message]');
		this.open = false;
		this.settings();
		this.addListener();
	}

	settings() {
		if (this.node.getAttribute('data-popup') !== '') {
			this.message.style.width = this.node.getAttribute('data-popup') + 'px';
		} else {
			this.message.style.width = '200px';
		}
	}

	addListener() {
		this.icon.addEventListener('click', this.clickIcon.bind(this));

		window.addEventListener('scroll', (e) => {
			if (this.open) {
				Popup.reset();
				this.open = false;
			}
		});
	}

	clickIcon(e) {
		const clones = Array.prototype.slice.call(document.querySelectorAll('.popup__message--cloned'));
		const actives = Array.prototype.slice.call(document.querySelectorAll('.popup--active'));

		if (this.open) {
			this.cloned.remove();
			this.open = false;
		} else {
			//if (clones.lenght !== 0) {
			//    clones.forEach(x => x.remove());
			//    actives.forEach(y => y.classList.remove('popup--active'));
			//}
			this.cloned = this.message.cloneNode(true);
			this.cloned.classList.remove('popup__message');
			this.cloned.classList.add('popup__message--cloned');
			document.body.appendChild(this.cloned);
			this.setPosition();
			this.open = true;
		}
		Utils.toggleClass(this.node, 'popup--active');
	}

	setPosition() {
		const x = this.icon.getBoundingClientRect().x;
		const y = this.icon.getBoundingClientRect().y;
		const padding = 20;
		const iconWidth = this.icon.offsetWidth;
		const iconHeight = this.icon.offsetHeight;
		const clonedWidth = this.cloned.offsetWidth;
		const clonedHeight = this.cloned.offsetHeight;
		if (this.cloned.getAttribute('data-popup-position') && this.cloned.getAttribute('data-popup-position') === 'left') {
			this.cloned.style.left = x - clonedWidth - iconWidth + 'px';
			this.cloned.classList.add('popup__message--left');
		} else {
			this.cloned.style.left = x + iconWidth + padding + 'px';
		}
		this.cloned.style.top = y - (clonedHeight / 2) + (iconHeight / 2) + 'px';
	}

	static reset() {
		const clones = Array.prototype.slice.call(document.querySelectorAll('.popup__message--cloned'));
		const actives = Array.prototype.slice.call(document.querySelectorAll('.popup--active'))
		if (clones.lenght !== 0) {
			clones.forEach(x => x.remove());
			actives.forEach(x => x.classList.remove('popup--active'));
		}
	}

	static init(container) {
		Popup.items = Array.prototype.slice.call(container.querySelectorAll('[data-popup]')).map((element, id) => {
			return new Popup(element, id);
		});
		// debug__('Popup: ', Popup.items);
	}
}
